import React from 'react'
import styled from 'styled-components'
import { Box } from '../../components/atoms'
import { PDFPagePreview } from './PDFPagePreview'

const PageContent = styled.div`
  padding: 26px;
  height: fit-content;
  display: flex;
  flex-direction: column;
`

interface PDFPageLayoutProps {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
}

export const PDFPageLayout: React.FC<PDFPageLayoutProps> = ({
  children,
  header,
  footer,
}) => {
  return (
    <PDFPagePreview>
      <PageContent>
        {header}
        <Box style={{ flex: 1 }}>{children}</Box>
        {footer}
      </PageContent>
    </PDFPagePreview>
  )
}
